var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
import PropTypes from "prop-types";

export default function Icon(props) {
  var icon = require("assets/" + (props.hasOwnProperty("path") ? props.path : "icons") + "/" + props.name + ".svg").default;

  // Keep the DOM clean by not putting name or description in it.
  var filteredProps = Object.keys(props).filter(function (key) {
    return !["name", "description", "tooltip", "setTooltipText", "path"].includes(key);
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {});

  return React.createElement(
    "svg",
    _extends({ viewBox: icon.viewBox }, filteredProps),
    React.createElement(
      "title",
      null,
      props.hasOwnProperty("description") ? props.description : props.name + " icon"
    ),
    React.createElement("use", { xlinkHref: "#" + icon.id })
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/components/Library/Icon/Icon.js